import { tss } from 'tss-react/mui';

const useStyles = tss
  .withParams<{
    styleHeaderAsSection?: boolean;
  }>()
  .create(({ theme, styleHeaderAsSection }) => ({
    assetDetailsPanelChips: {
      marginBottom: '.5rem',
      marginRight: '.5rem'
    },
    panelProviderTitle: {
      fontSize: '1.25rem',
      fontWeight: 600,
      marginBottom: theme.spacing(1),
      width: '100%'
    },
    panelContent: {
      padding: '1rem'
    },
    panelContentDivider: {
      padding: '0.5rem 0'
    },
    panelContentSection: {
      margin: '0 0 1rem 0'
    },
    panelContentTitle: {
      fontSize: styleHeaderAsSection ? '1.25rem' : '0.75rem',
      width: '100%',
      ...(!styleHeaderAsSection && {
        color: theme.vars.palette.text.secondary
      }),
      ...(styleHeaderAsSection && {
        fontWeight: 600
      })
    }
  }));

export default useStyles;
